import { FC } from "react";
import { map, isEmpty, join } from "lodash-es";

import { Card } from "shared/components";
import { copy } from "shared/assets";
import { getMemberSettingsActions, useBandRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";
import { User } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import { BoldText, MutedText } from "shared/styles";
import { useBandContext, usePermissionsContext } from "Bands/contexts";

const {
  bandSettings: { bandSettingsIds, sidemenu, memberSettings },
} = copy;

export const MemberSettings: FC = () => {
  const { pushRoute } = useBandRoute();
  const { memberCategories } = useBandContext();

  const { bandPermissions } = usePermissionsContext();

  const handleEdit = () => {
    pushRoute(BAND_PATHS.EDIT_BAND_SETTINGS_MEMBER);
  };

  const actions = bandPermissions.EDIT
    ? getMemberSettingsActions({
        handleEdit,
      })
    : [];

  return (
    <Card
      id={bandSettingsIds.member}
      icon={User}
      title={sidemenu.member}
      actions={actions}
      actionDataTestId="member_settings_actions"
    >
      <Spacer size="l">
        {!isEmpty(memberCategories) && (
          <Spacer size="s">
            <BoldText>{memberSettings.memberCategories.title}</BoldText>
            <MutedText>
              {join(
                map(memberCategories, ({ label }) => label),
                ", "
              )}
            </MutedText>
          </Spacer>
        )}
      </Spacer>
    </Card>
  );
};
